/**
 * Web shim for react-native-share.
 *
 * The real package resolves its native TurboModule at import time
 * (TurboModuleRegistry.getEnforcing('RNShare')), which throws on web and
 * killed the route chunk expo-router preloads.
 *
 * Fallback ladder (best first):
 *  1. Web Share API with files — image + caption text (the caption carries
 *     the https trail link, matching the native share payload).
 *  2. No (or file-less) Web Share API — download the PNG locally and copy
 *     the caption/link to the clipboard, so both bits still reach the user.
 */
async function downloadDataUri(url, fileName) {
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName || 'tailtrails-share.png';
  document.body.appendChild(a);
  a.click();
  a.remove();
}

async function share(opts = {}) {
  // 1. Full share sheet with image + caption (caption holds the trail link).
  let files;
  if (typeof opts.url === 'string' && opts.url.startsWith('data:')) {
    try {
      const blob = await (await fetch(opts.url)).blob();
      files = [new File([blob], opts.fileName || 'tailtrails-share.png', { type: blob.type || 'image/png' })];
    } catch {
      files = undefined;
    }
  }
  if (files && navigator.canShare && navigator.canShare({ files })) {
    await navigator.share({ files, title: opts.title, text: opts.message });
    return { success: true, message: '' };
  }

  // Plain link/text share when no file is involved (e.g. the explicit
  // "Share Trail" button) — the URL is the payload itself.
  if (navigator.share && typeof opts.url === 'string' && opts.url && !opts.url.startsWith('data:')) {
    await navigator.share({ title: opts.title, text: opts.message, url: opts.url });
    return { success: true, message: '' };
  }

  // 2. Fallback: save the image + put the caption/link on the clipboard.
  let downloaded = false;
  if (typeof opts.url === 'string' && opts.url.startsWith('data:')) {
    try {
      await downloadDataUri(opts.url, opts.fileName);
      downloaded = true;
    } catch {
      downloaded = false;
    }
  }
  const caption = [
    opts.message,
    typeof opts.url === 'string' && !opts.url.startsWith('data:') ? opts.url : '',
  ]
    .filter(Boolean)
    .join(' ')
    .trim();
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(caption).catch(() => {});
  }
  return { success: true, message: downloaded ? 'Image saved & link copied' : 'Link copied' };
}

const Share = {
  open: share,
  share: share,
  isPackageInstalled: async () => false,
  Social: {},
};

module.exports = Share;
module.exports.default = Share;
module.exports.__esModule = true;